
<template lang="html">
<div>

    <div class="subpage">

          <div class="pgLeft">原文</div>
          <div class="pgContent">
             <textEditor ref="textEditor" :inContent="params.directoryTextContent" />
          </div>

    </div>

</div>
</template>

<script>
import Editor from "@/components/KindEditor/KindEditor";
import { pocTextGet } from "@/api/policies/policies";
export default {

    data(){
        return{
            params:{
                type:1,
                id:'',
                directoryTextContent:''
            }
        }
    },

    methods:{
        saveReturn:function(){
            this.params.directoryTextContent = this.$refs.textEditor.editorContent;
            if(this.params.directoryTextContent){
                return this.params;
            }else{
                return false;
            }
        }
    },
    created:function(){

        var vues = this;
        var querys = this.$route.query;

        if(querys.id){
            pocTextGet({cqjSbzcDeclarationPolicyId:querys.id,type:1}).then(res => {
                vues.params.directoryTextContent = res.policyReleaseContentList[0].directoryTextContent;
                vues.$emit('inited');
            })
        }

    }
}
</script>

<style lang="scss" scoped>

.subpage{
      font-size: 14px;
     .pgLeft{
          width: 60px;
          float: left
     }
     .pgContent{
          margin-left: 60px;
          position: relative;

     }
     .cblock{

     }

}

</style>



// WEBPACK FOOTER //
// Subpage2.vue?1a1ac3ce